import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Popover, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';

const RememberMePopover: FC = () => {
  const { t } = useTranslation(['login', 'common']);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <IconButton onClick={handleClick}>
        <HelpOutlineIcon sx={{ width: 20, height: 20 }} />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        slotProps={{
          paper: { style: { width: 300 } },
        }}
      >
        <Typography sx={{ p: 2 }}>{t('login:rememberMePopover')}</Typography>
      </Popover>
    </div>
  );
};

export default RememberMePopover;
